import { render, staticRenderFns } from "./SuperPartnerReg.vue?vue&type=template&id=6e87be48&scoped=true"
import script from "./SuperPartnerReg.vue?vue&type=script&lang=js"
export * from "./SuperPartnerReg.vue?vue&type=script&lang=js"
import style0 from "./SuperPartnerReg.vue?vue&type=style&index=0&id=6e87be48&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e87be48",
  null
  
)

export default component.exports